import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap";
import {Subject} from "rxjs";

@Component({
  selector: 'app-certificate-signature-side-panel',
  templateUrl: './certificate-signature-side-panel.component.html',
  styleUrls: ['./certificate-signature-side-panel.component.scss']
})
export class CertificateSignatureSidePanelComponent implements OnInit {
  signatureText: string = '';
  base64Image: string = '';
  onClose: Subject<any>;
  @Input() showSignatureSidePanel = false;
  @Output() onSignatureGenerate: EventEmitter<any> = new EventEmitter();
  @Output() closeEmitter: EventEmitter<any> = new EventEmitter();
  @Input() screenFor:number=0;
  constructor(private bsModalRef: BsModalRef,) { }

  ngOnInit() {
    this.onClose = new Subject();
  }

  onSidepanelClose(){
    this.bsModalRef.hide();
  }

  getSignature(base64Image){
    this.base64Image = base64Image;
  }

  insertSignature(){
    this.onSignatureGenerate.emit(this.base64Image);
    this.signatureText = '';
    this.onClose.next(this.base64Image);
    this.bsModalRef.hide();
  }

}
